<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="名称或条码" @input="handleKeyPress" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.form" placeholder="规格" @input="handleKeyPress" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.brand" placeholder="品牌" @input="handleKeyPress" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-checkbox v-model="priceNull" @change="getGoods">无价格</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-button type="warning" @click="handleAdd">新增</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="isBatAddShow=true" >批量导入</el-button>
					<el-input id="upload" type="file" size="mini" @change="importFromExcel(this)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none;"></el-input>
				</el-form-item>
			</el-form>
		</el-col>

		<!--批量导入界面-->
		<el-dialog title="批量导入" :visible.sync="isBatAddShow" :close-on-click-modal="false" width="30%">
			<div>
				<font color="red"><b>请按照模版进行填写，文件后缀为.xlsx&nbsp;&nbsp;&nbsp;&nbsp;</b></font>
				<a href="https://mapi.dxx2xxn.cn/xlsx/itemTemplate/批量上传模板.xlsx" target="_blank" style="font-size:18px;color:#CD6839;">下载模版</a>
				&nbsp;
				<el-button @click.native="uploadClick" style="font-size:18px;color:green">立即上传</el-button>
			</div>
		</el-dialog>

		<!--列表-->
		<el-table :data="goods" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="barCode" label="条形码" width="150">
			</el-table-column>
			<el-table-column prop="name" show-overflow-tooltip label="名称" width="100" sortable>
			</el-table-column>
			<el-table-column prop="brand" label="品牌" width="100">
			</el-table-column>
			<el-table-column prop="form" show-overflow-tooltip label="规格" width="100">
			</el-table-column>
			<el-table-column prop="unit" label="单位" width="80">
			</el-table-column>
			<el-table-column prop="price" label="价格" width="80">
			</el-table-column>
			<el-table-column prop="stock" label="库存" width="100" sortable>
			</el-table-column>
			<el-table-column label="操作" width="380">
				<template scope="scope">
					<!-- <el-button size="small" type="warning" icon="fa fa-file-picture-o" :disabled="scope.row.imgurl==''" @click="handlePrint(scope.$index, scope.row)"></el-button> -->
					<el-button size="small" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"></el-button>
					<el-button size="small" type="danger" v-if="isAdmin" icon="el-icon-delete" @click="handleDel(scope.$index, scope.row)"></el-button>
					<el-button size="small" v-if="isAdmin" @click="handleRecent(scope.$index, scope.row)">进货历史</el-button>
					<el-button size="small" @click="handleRelated(scope.$index, scope.row)">相关订单</el-button>
					<el-button size="small" @click="handleCopyAdd(scope.$index, scope.row)">复制</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				<el-form-item label="条形码" prop="barCode">
					<el-input v-model="editForm.barCode"></el-input>
				</el-form-item>
				<el-form-item label="名称" prop="name">
					<el-input v-model="editForm.name" @input="getFirstLetter"></el-input>
				</el-form-item>
				<el-form-item label="大写" prop="firstLetter">
					<el-input v-model="editForm.firstLetter"></el-input>
				</el-form-item>
				<el-form-item label="品牌" prop="brand">
					<el-input v-model="editForm.brand"></el-input>
				</el-form-item>
				<el-form-item label="规格" prop="form">
					<el-input v-model="editForm.form"></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
					<el-input v-model="editForm.unit"></el-input>
				</el-form-item>
				<el-form-item label="价格" prop="price">
					<el-input type="number" v-model="editForm.price" :min="0" :max="99999"></el-input>
				</el-form-item>
				<el-form-item label="图片" prop="imgurl">
					<el-upload
					  class="avatar-uploader"
					  action=""
					  accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP"
					  :http-request="uploadImg"
					  :show-file-list="false">
					  <img v-if="editForm.imgurl && this.uploadFlag == false" :src="editForm.imgurl" class="avatar">
					  <i v-else-if="!editForm.imgurl && this.uploadFlag == false" class="el-icon-plus avatar-uploader-icon"></i>
					  <el-progress v-if="this.uploadFlag" type="circle" :percentage="uploadPercent" style="margin-top:30px;margin-left:25px;"></el-progress>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
				<el-form-item label="条形码" prop="barCode">
					<el-input v-model="addForm.barCode"></el-input>
				</el-form-item>
				<el-form-item label="名称" prop="name">
					<el-input v-model="addForm.name" @input="getFirstLetter"></el-input>
				</el-form-item>
				<el-form-item label="大写" prop="firstLetter">
					<el-input v-model="addForm.firstLetter"></el-input>
				</el-form-item>
				<el-form-item label="品牌" prop="brand">
					<el-input v-model="addForm.brand"></el-input>
				</el-form-item>
				<el-form-item label="规格" prop="form">
					<el-input v-model="addForm.form"></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
					<el-input v-model="addForm.unit"></el-input>
				</el-form-item>
				<el-form-item label="价格" prop="price">
					<el-input type="number" v-model="addForm.price" :min="0" :max="99999"></el-input>
				</el-form-item>
				<el-form-item label="图片" prop="imgurl">
					<el-upload
					  class="avatar-uploader"
					  action=""
					  accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP"
					  :http-request="uploadImg"
					  :show-file-list="false">
					  <img v-if="addForm.imgurl && this.uploadFlag == false" :src="addForm.imgurl" class="avatar">
					  <i v-else-if="!addForm.imgurl && this.uploadFlag == false" class="el-icon-plus avatar-uploader-icon"></i>
					  <el-progress v-if="this.uploadFlag" type="circle" :percentage="uploadPercent" style="margin-top:30px;margin-left:25px;"></el-progress>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--进货历史界面-->
		<el-dialog title="进货历史" :visible.sync="recentFormVisible" :close-on-click-modal="false">
			<el-table :data="recentGoods" highlight-current-row v-loading="recentLoading" style="width: 100%;" >
			    <el-table-column type="index" width="55">
				</el-table-column>
				<el-table-column prop="stockTime" label="进货日期" width="110">
				</el-table-column>
				<el-table-column prop="count" label="数量" width="80">
				</el-table-column>
				<el-table-column prop="bidPrice" label="进价" width="70">
				</el-table-column>
				<el-table-column prop="provider" label="供应商" width="400">
				</el-table-column>
			</el-table>
		</el-dialog>

		
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import _ from 'lodash';
	import '../../common/js/pinyinUtil.js'
	import Cookies from 'js-cookie'
	import { getGoodsList, addGoods, editGoods, batAddGoods, getRecentGoodsList, fileGoodsUpload, getOrdersByGoodsId} from '../../api/api';
	export default {
		data() {
			return {
				//价格是否为空
				priceNull:false,
				isAdmin: Cookies.get('user_type')==1,
				filters: {
					name: '',
					form: '',
					brand: ''
				},
				goods: [],
				total: 0,
				page: 1,
				pageSize: 20,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入物料名称', trigger: 'blur' }
					],
					unit: [
						{ required: true, message: '请输入单位', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入物料名称', trigger: 'blur' }
					],
					unit: [
						{ required: true, message: '请输入单位', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
				},

				//进货历史界面
				recentFormVisible: false,//进货历史界面是否显示
				recentLoading: false,
				recentGoods: [],

				//图片上传
				uploadFlag: false,
				uploadPercent:0,


				isBatAddShow:false,

				handleKeyPress:_.debounce(this.getGoods, 100) // 500毫秒内只触发一次
			}
		},
		methods: {
			//页数变化处理
			handleCurrentChange(val) {
				this.page = val;
				this.getGoods();
			},
			//页大小变化处理
			handleSizeChange(val){
				this.pageSize = val;
				this.getGoods();
			},
			uploadClick(){
				this.isBatAddShow = false;
				document.getElementById("upload").click();
			},
			//导入excel数据
			importFromExcel: function(obj) {
		        let _this = this;
		        let inputDOM = this.$refs.inputer;
		        // 通过DOM取文件数据
		        this.file = event.currentTarget.files[0];
		        //判断文档格式是否为xlsx
		        let fileName = this.file.name;

		        let suffix = fileName.substring(fileName.lastIndexOf('.')+1);
		        if(suffix!='xlsx'){
		        	_this.$message({
	                  message: '上传失败，请检查文档是否为xlsx格式',
	                  type: 'error'
	                });
	                return;
		        }
		        var rABS = false; //是否将文件读取为二进制字符串
		        var f = this.file;
		        var reader = new FileReader();
		        //if (!FileReader.prototype.readAsBinaryString) {
		        FileReader.prototype.readAsBinaryString = function(f) {
		            var binary = "";
		            var rABS = false; //是否将文件读取为二进制字符串
		            var pt = this;
		            var wb; //读取完成的数据
		            var outdata;
		            var reader = new FileReader();
		            reader.onload = function(e) {
		                var bytes = new Uint8Array(reader.result);
		                var length = bytes.byteLength;
		                for(var i = 0; i < length; i++) {
		                    binary += String.fromCharCode(bytes[i]);
		                }
		                var XLSX = require('xlsx');

		                if(rABS) {
		                    wb = XLSX.read(btoa(fixdata(binary)), { //手动转化
		                        type: 'base64'
		                    });
		                } else {
		                    wb = XLSX.read(binary, {
		                        type: 'binary'
		                    });
		                }

		                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
		                this.da = [...outdata]
		                let arr = []
		                this.da.map(v => {
		                    let obj = {}
		                    obj.barCode = v.barCode
		                    obj.name = v.name
		                    obj.firstLetter = pinyinUtil.getFirstLetter(v.name)
		                    obj.brand = v.brand
		                    obj.form = v.form
		                    obj.unit = v.unit
		                    obj.price = v.price
		                    obj.stock = v.stock ? v.stock : 0
		                    obj.status = 1
		                    arr.push(obj)
		                })
		                batAddGoods(JSON.stringify(arr)).then(res => {
		                	if (res.data.code !== 200) {
		                		let msg = res.data.message;
		                		let index = msg.lastIndexOf(":")
		                		msg = msg.substring(index).split("'")[1]
				                _this.$message({
				                  message: '上传失败，"'+msg+'" 不能为空，请检查文档内容',
				                  type: 'error'
				                });
				              } else {
				                _this.$message({
				                  message: '上传成功',
				                  type: 'success'
				                });
				                _this.getGoods();
				              }
				              document.getElementById("upload").value = '';
		                })
		            }
		            reader.readAsArrayBuffer(f);
		        }
		        if(rABS) {
		            reader.readAsArrayBuffer(f);
		        } else {
		            reader.readAsBinaryString(f);
		        }
		    },
	    //物料图片
  		handlePrint: function (index, row) {
  			window.open(row.imgurl);
  		},
			//获取首字母
			getFirstLetter:function(){
				this.addForm.firstLetter = pinyinUtil.getFirstLetter(this.addForm.name);
				this.editForm.firstLetter = pinyinUtil.getFirstLetter(this.editForm.name);
			},
			//获取物料倩价列表
			getGoods() {
				let para = {
					page:this.page,
                    size:this.pageSize,
                    name:this.filters.name,
                    form:this.filters.form,
                    brand:this.filters.brand,
                    priceNull:this.priceNull,
				};
				this.listLoading = true;
				getGoodsList(para).then((res) => {
					this.listLoading = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.goods = res.data.data.list
	                    this.page = res.data.data.pageNum == 0 ? res.data.data.pageNum +1 : res.data.data.pageNum
	                    this.total = res.data.data.total
	                }
				});
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					let para = { id: row.id, status: 0 };
					editGoods(para).then((res) => {
						this.listLoading = false;
						let msg = res.data.message;
	                	let code = res.data.code;
						if (code !== 200) {
		                  this.$message({
		                    message: msg,
		                    type: 'error'
		                  });
		                } else {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getGoods();
						}
					});
				}).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					barCode: '',
					name: '',
					firstLetter: '',
					brand: '',
					form: '',
					unit: '',
					price: 0,
				};
			},

			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.editLoading = true;
						let para = Object.assign({}, this.editForm);
						para.createTime = undefined;
						para.updateTime = undefined;
						editGoods(para).then((res) => {
							this.editLoading = false;
							this.editFormVisible = false;
							let msg = res.data.message;
		                	let code = res.data.code;
							if (code !== 200) {
			                  this.$message({
			                    message: msg,
			                    type: 'error'
			                  });
			                } else {
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.getGoods();
								this.$refs['editForm'].resetFields();
							}
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.addLoading = true;
						let para = Object.assign({}, this.addForm);
						addGoods(para).then((res) => {
							this.addLoading = false;
							this.addFormVisible = false;
							let msg = res.data.message;
		                	let code = res.data.code;
							if (code !== 200) {
			                  this.$message({
			                    message: msg,
			                    type: 'error'
			                  });
			                } else {
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addForm'].resetFields();
								this.getGoods();
							}
						});
					}
				});
			},
			//最近进货列表
	  		handleRecent: function (index, row) {
	  			let para = {
	            	goodsId:row.id
				};
				getRecentGoodsList(para).then((res) => {
					let msg = res.data.message;
	      			let code = res.data.code;
					if (code !== 200) {
			          this.$message({
			            message: msg,
			            type: 'error'
			          });
			        } else {
			        	this.recentGoods = res.data.data
			        	this.recentFormVisible = true
					}
				});
	  		},

	  		//商品相关订单
			handleRelated: function (index, row) {
				let para = {
					page:1,
	                size:20,
	                goodsId:row.id
				};
				getOrdersByGoodsId(para).then((res) => {
					let msg = res.data.message;
	            	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
	                	res.data.data.name = '商品列表';
	                	res.data.data.para = para;
	                	res.data.data.filters = this.filters;
						this.$router.push({name: '销货单列表', params: {relatedResponse: res}});
					}
				});
			},
	  		//复制
	  		handleCopyAdd: function (index, row) {
	  			this.addFormVisible = true;
					this.addForm = row;
					this.addForm.id='';
	  		},
  			uploadImg(content){
		    	this.uploadPercent = 0;
			    this.uploadFlag = true;
			    let _this = this;
			    clearInterval(this.time);
			    this.time = setInterval(function(){  
		           if(_this.uploadPercent<75){
		               _this.uploadPercent += 25;//进程条
		           }else{                 
		           }          
		        },100)
		    	var formData = new FormData();
		    	formData.append("file", content.file);
		    	fileGoodsUpload(formData).then((res) => {
			        this.uploadFlag = false;
			        let msg = res.data.message;
            	let code = res.data.code;
							if (code !== 200) {
                this.$message({
                  message: msg,
                  type: 'error'
                });
              } else {
								this.addForm.imgurl = res.data.data;
								this.editForm.imgurl = res.data.data;
							}
		    	});
		    }, 
		},
		mounted() {
			this.getGoods();
		},
	}

</script>

<style scoped>
	i:hover{ 
		color:#999;
		cursor: pointer;
	}

 .avatar-uploader{
 	width: 178px;
    height: 178px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-upload {
  	margin-left: 25px;
  }
  img{
  	width:100%;
  	height:100%;
  }

</style>

<style media="print">
    @page {
        size: auto;  /* auto is the initial value */
        margin: 0mm; /* this affects the margin in the printer settings */
    }
</style>

